var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupSpecialties(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "209.798px",
    height: "117.25px",
    viewBox: "8.001 0 209.798 117.25",
    enableBackground: "new 8.001 0 209.798 117.25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M161.401,27.524c19.6,33.301,26,55,26.699,57.5c16.102-4.1,29.699-10.6,29.699-10.6s-4-15.1-18.1-38.9 c-11.5-19.5-15.8-23.1-18.8-26.3c-3.101-3.1-6.5-2.399-9-0.1c-2.101,1.7-5.2,4.6-6.399,5.6c-1.101-1-4.301-3.899-6.4-5.6 c-2.6-2.101-6-3-9,0.1C153.301,14.125,157,20.024,161.401,27.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M40.001,85.325c0.2-0.9,6.3-23,26.7-57.7c4-6.8,7.4-12.3,10.4-16.8c-0.5-0.5-1-1-1.4-1.4 c-3.1-3.1-6.5-2.4-9-0.1c-2.1,1.699-5.2,4.6-6.4,5.6c-1.1-1-4.3-3.9-6.4-5.6c-2.6-2.2-6-3-9,0.1c-3.1,3.1-7.4,6.8-18.8,26.3 c-14.1,23.7-18.1,38.8-18.1,38.8s14.9,7.101,32,11.101V85.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M47.733,96.725c0,0,32.868,20.2,66.468,20.2c33.6,0,65.198-18.8,65.198-18.8s-0.667-18.833-15.999-57 c-16.5-28-22.699-33.2-27.102-37.8C134.2,1.225,131.958,0,129.858,0c-2.4,0-4.656,1.425-6.559,3.125 c-3,2.5-4.357,2.203-9.148,2.337c-3.96-0.039-6.251,0.163-9.251-2.337c-2-1.7-4.6-3.125-7-3.125c-2.1,0-4,1.225-6,3.325 c-4.4,4.5-10.6,9.8-27.1,37.8C50.184,75.068,47.733,96.725,47.733,96.725z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "129,93.225 117.601,93.225 117.601,81.925 110.702,81.925 110.702,93.225 99.301,93.225  99.301,100.225 110.702,100.225 110.702,111.524 117.601,111.524 117.601,100.225 129,100.225  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M40.001,85.325c0.2-0.9,6.3-23,26.7-57.7c4-6.8,7.4-12.3,10.4-16.8c-0.5-0.5-1-1-1.4-1.4 c-3.1-3.1-6.5-2.4-9-0.1c-2.1,1.699-5.2,4.6-6.4,5.6c-1.1-1-4.3-3.9-6.4-5.6c-2.6-2.2-6-3-9,0.1c-3.1,3.1-7.4,6.8-18.8,26.3 c-14.1,23.7-18.1,38.8-18.1,38.8s14.9,7.101,32,11.101V85.325z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M26.401,28.125 c-1.9,4.3-3.2,8.6-3.2,12.399c0,14.101,31.2,16.9,36.6,16.9h0.1c5.4,0,36.6-2.8,36.6-16.9c0-3.8-1.3-8.1-3.2-12.399"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M161.401,27.524c19.6,33.301,26,55,26.699,57.5c16.102-4.1,29.699-10.6,29.699-10.6s-4-15.1-18.1-38.9 c-11.5-19.5-15.8-23.1-18.8-26.3c-3.101-3.1-6.5-2.399-9-0.1c-2.101,1.7-5.2,4.6-6.399,5.6c-1.101-1-4.301-3.899-6.4-5.6 c-2.6-2.101-6-3-9,0.1C153.301,14.125,157,20.024,161.401,27.524z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M132.401,28.125 c-1.9,4.3-3.199,8.6-3.199,12.399c0,14.101,31.199,16.9,36.6,16.9h0.101c5.399,0,36.601-2.8,36.601-16.9 c0-3.8-1.301-8.1-3.201-12.399"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M38.801,97.125c0,0,41.8,19.8,75.401,19.8c33.6,0,75.199-19.8,75.199-19.8s-5.801-21.7-26-56 c-16.5-28-22.699-33.2-27.102-37.8c-2.1-2.101-4.299-3-6.398-3c-2.4,0-4.699,1.1-6.602,2.8c-3,2.5-7.499,1.5-9.198,3 c-1.6-1.5-6.201-0.5-9.201-3c-2-1.7-4.3-2.8-6.7-2.8c-2.1,0-4.3,0.899-6.3,3c-4.4,4.5-10.6,9.8-27.1,37.8 C44.601,75.425,38.801,97.125,38.801,97.125z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M66.401,30.925 c-2.7,6.1-4.5,12.3-4.5,17.6c0,20,44.301,24,52,24h0.2c7.7,0,52-4,52-24c0-5.399-1.8-11.5-4.5-17.6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSpecialties);
export default __webpack_public_path__ + "static/media/group_specialties.6b91209a645623ee3c8c5c4a7a0dbcde.svg";
export { ForwardRef as ReactComponent };